import { render, staticRenderFns } from "./PendingApprovalPersonalLoanModal.vue?vue&type=template&id=3185348a"
import script from "./PendingApprovalPersonalLoanModal.vue?vue&type=script&lang=js"
export * from "./PendingApprovalPersonalLoanModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports